module.exports = __webpack_public_path__ + "static/boss3.e571cce7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/boss3.png
// module id = 3048
// module chunks = 219286714057974